<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">

      <div class="spacer2"></div>

      <div class="containter">
        <div class="mfhd">
          <a class="pointer" [routerLink]="['/shared-workspaces']">
            <i class="fa fa-angle-left" aria-hidden="true" style="padding-right: 5px"></i>
          </a>
          {{ workspace?.name || 'Workspace' }}
          <span class="swd-role" *ngIf="!loading">{{ isOwner ? 'You own this' : 'Read only' }}</span>
          <div class="page-description" *ngIf="!loading">
            <ng-container *ngIf="isOwner">
              People you invite here can read what you share into this workspace. They cannot add,
              change or remove anything.
            </ng-container>
            <ng-container *ngIf="!isOwner">
              You can read what has been shared here. Nothing you write goes into this workspace.
            </ng-container>
          </div>
        </div>

        <div class="swd-loading" *ngIf="loading">
          <mat-spinner diameter="28"></mat-spinner>
        </div>

        <mat-tab-group *ngIf="!loading" animationDuration="0ms">

          <!-- what is in it -->
          <mat-tab label="Shared items">
            <div class="swd-tab">
              <div class="swd-toolbar">
                <button mat-button [class.swd-on]="itemType === 'MEMORY'"
                  (click)="switchType('MEMORY')">Memories</button>
                <button mat-button [class.swd-on]="itemType === 'RECIPE'"
                  (click)="switchType('RECIPE')">Recipes</button>
                <span class="swd-spacer"></span>
                <button mat-button (click)="loadItems()" [disabled]="loadingItems">Refresh</button>
              </div>

              <div class="swd-loading" *ngIf="loadingItems">
                <mat-spinner diameter="24"></mat-spinner>
              </div>

              <div class="swd-empty" *ngIf="!loadingItems && !items.length">
                Nothing has been shared into this workspace yet.
                <div class="swd-sub" *ngIf="isOwner">
                  Sharing is a separate step: you write a memory in your own workspace, then share it here.
                </div>
              </div>

              <div class="memories-container grid-view"
                *ngIf="!loadingItems && itemType === 'MEMORY' && items.length">
                <app-memory-card *ngFor="let item of items; let i = index"
                  [memory]="item" [index]="i + 1"></app-memory-card>
              </div>

              <div class="recipes-container grid-view"
                *ngIf="!loadingItems && itemType === 'RECIPE' && items.length">
                <app-recipe-card *ngFor="let item of items; let i = index"
                  [recipe]="item" [index]="i + 1"></app-recipe-card>
              </div>
            </div>
          </mat-tab>

          <!-- who can read it -->
          <mat-tab label="People">
            <div class="swd-tab">
              <table mat-table [dataSource]="members" class="mat-elevation-z8">
                <ng-container matColumnDef="person">
                  <th mat-header-cell *matHeaderCellDef>Person</th>
                  <td mat-cell *matCellDef="let m">
                    {{ m.name || m.email }}
                    <div class="swd-sub" *ngIf="m.name">{{ m.email }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="access">
                  <th mat-header-cell *matHeaderCellDef>Access</th>
                  <td mat-cell *matCellDef="let m">
                    <span class="swd-tag">{{ m.access === 'READ_WRITE' ? 'Owner' : 'Read only' }}</span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="joined">
                  <th mat-header-cell *matHeaderCellDef>Joined</th>
                  <td mat-cell *matCellDef="let m">{{ formatDate(m.joinedAt) }}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let m">
                    <button mat-button *ngIf="isOwner && m.role !== 'OWNER'"
                      (click)="remove(m)" [disabled]="busy">Remove</button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="['person', 'access', 'joined', 'actions']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['person', 'access', 'joined', 'actions']"></tr>
              </table>
              <div class="swd-sub swd-note">
                Everyone here can see this list. Knowing who else is in the room is part of the deal.
              </div>
            </div>
          </mat-tab>

          <!-- invitations -->
          <mat-tab label="Invitations" *ngIf="isOwner">
            <div class="swd-tab">
              <div class="swd-invite-form">
                <mat-form-field appearance="outline" class="swd-email">
                  <mat-label>Email address</mat-label>
                  <input matInput [(ngModel)]="inviteEmail" placeholder="someone@example.com"
                    (keyup.enter)="sendInvite()" [disabled]="busy" />
                </mat-form-field>
                <button mat-raised-button color="primary" class="btn-send clr-white"
                  (click)="sendInvite()" [disabled]="busy">Send invitation</button>
                <div class="swd-sub">
                  They get a link that only works when signed in as that address, and it expires.
                </div>
              </div>

              <div class="swd-empty" *ngIf="!invites.length">No invitations yet.</div>

              <table mat-table [dataSource]="invites" class="mat-elevation-z8" *ngIf="invites.length">
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef>Invited</th>
                  <td mat-cell *matCellDef="let i">{{ i.email }}</td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let i"><span class="swd-tag">{{ i.status }}</span></td>
                </ng-container>
                <ng-container matColumnDef="sent">
                  <th mat-header-cell *matHeaderCellDef>Sent</th>
                  <td mat-cell *matCellDef="let i">{{ formatDate(i.createdAt) }}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let i">
                    <button mat-button *ngIf="i.status === 'PENDING'"
                      (click)="revoke(i)" [disabled]="busy">Withdraw</button>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="['email', 'status', 'sent', 'actions']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['email', 'status', 'sent', 'actions']"></tr>
              </table>
            </div>
          </mat-tab>

        </mat-tab-group>

      </div>
    </div>
  </div>
</div>
